export const selectAllEvents = (state) => state.events;
